export type FormType = "member" | "creator";
export type SubmitStatus = "success" | "duplicate" | "error";
export type ErrorReason =
  | "validation"
  | "rate_limited"
  | "member_conflict"
  | "profile_update_failed"
  | "server"
  | "network";

export const EVENTS = {
  LEAD_FORM_START: "lead_form_start",
  LEAD_SUBMIT: "lead_submit",
  CTA_CLICK: "cta_click",
  EXPERIMENT_EXPOSURE: "experiment_exposure",
  BOT_SUSPECTED: "bot_suspected",
} as const;

/**
 * Map an internal event to its GA4 event name. Returns null when the event must
 * not reach GA. Only a successful submit becomes the `generate_lead` key event
 * (the Google Ads conversion); other submits stay `lead_submit` for funnel use.
 */
export function gaEventName(name: string, status?: SubmitStatus): string | null {
  if (name === EVENTS.BOT_SUSPECTED) return null;
  if (name === EVENTS.LEAD_SUBMIT) return status === "success" ? "generate_lead" : "lead_submit";
  return name;
}
